import { NativeClientService } from '@shared/services/native-client.service';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectOnboardingBaseUrl } from '../store/selectors/onboarding-config.selectors';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private blackListBasesUrls: string[] = [];

  constructor(
    private authService: AuthService,
    private nativeClientService: NativeClientService,
    private store: Store,
  ) {
    /** @todo create public method to populate blacklist */
    this.store
      .pipe(selectOnboardingBaseUrl)
      .subscribe((onboardingBaseUrl: string) => {
        if (
          onboardingBaseUrl &&
          !this.blackListBasesUrls.includes(onboardingBaseUrl)
        ) {
          this.blackListBasesUrls.push(onboardingBaseUrl);
        }
      });
  }

  /**
   * Intercept and modify the http requests globally before they are sent to the server.
   *
   * @param req the request to modify.
   * @param next transforms an HttpRequest into a stream of HttpEvents
   * @return the modified request
   */
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let request = req;
    if (this.nativeClientService.isNative && this.nativeClientService.headerValues) {
      request = req.clone({
        headers: req.headers.set(
          'Authorization',
          `Bearer ${this.nativeClientService.headerValues}`,
        ),
      });
    }
    if (
      !this.nativeClientService.isNative &&
      this.authService.getToken() !== null &&
      !this.blackListBasesUrls.some((baseUrl) => req.url.startsWith(baseUrl))
    ) {
      request = req.clone({
        headers: req.headers.set('X-CSRF-TOKEN', this.authService.getToken()),
      });
    }

    return next.handle(request);
  }
}
